import { cn } from "../../lib/utils";

export function PageHeader({ title, kicker, description, actions, className }) {
  return (
    <div
      data-testid="page-header"
      className={cn(
        "flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between mb-8",
        className
      )}
    >
      <div className="space-y-2">
        {kicker && (
          <div className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.22em] text-[var(--pl-aqua)]">
            <span className="h-1 w-1 rounded-full bg-[var(--pl-aqua)] shadow-[0_0_10px_var(--pl-aqua)]" />
            {kicker}
          </div>
        )}
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[var(--pl-text)]">
          {title}
        </h1>
        {description && (
          <p className="text-sm sm:text-base text-[var(--pl-text-muted)] max-w-2xl">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function GlassCard({ className, children, ...rest }) {
  return (
    <div
      className={cn(
        "rounded-2xl border border-[var(--pl-border)] backdrop-blur-xl pl-contour-card pl-lift",
        className
      )}
      style={{ background: "color-mix(in srgb, var(--pl-surface) 70%, transparent)" }}
      {...rest}
    >
      {children}
    </div>
  );
}
